import type { UntypedFunction } from '@mnd-frontend/ts';

const noop: UntypedFunction = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function

export class UploadQueue {
  private queueList: Blob[] = [];

  private onFileUploaded: () => void = noop;

  private onCountChanged: (filesLeft: number) => void = noop;

  private onCompleted: () => void = noop;

  private onStarted: (filesLeft: number) => void = noop;

  private upload: (file: Blob) => Promise<any> = noop;

  private running = false;

  private uploading = false;

  updateFunctionPointers({
    onCompleted,
    onFileUploaded,
    onCountChanged,
    upload,
    onStarted,
  }: {
    onCompleted: () => void;
    onFileUploaded: () => void;
    onCountChanged: (filesLeft: number) => void;
    upload: (file: Blob) => Promise<any>;
    onStarted: () => void;
  }) {
    this.onCompleted = onCompleted;
    this.onFileUploaded = onFileUploaded;
    this.onCountChanged = onCountChanged;
    this.upload = upload;
    this.onStarted = onStarted;
  }

  queue(blobs: Blob[]) {
    this.queueList.push(...blobs);
    this.countChanged();
    if (!this.running) {
      this.running = true;
      this.onStarted(this.queueList.length);
      this.recursiveUpload(this.queueList.shift());
    }
  }

  destroy() {
    this.onCountChanged(0);
    this.upload = noop;
    this.onCountChanged = noop;
    this.onStarted = noop;
    this.onFileUploaded = noop;
    this.onCompleted = noop;
    this.queueList = [];
  }

  countChanged() {
    this.onCountChanged(this.queueList.length + (this.uploading ? 1 : 0));
  }

  async recursiveUpload(file?: Blob) {
    if (!file) {
      this.onCompleted();
      this.running = false;
      return;
    }
    try {
      this.uploading = true;
      this.countChanged();

      await this.upload(file);

      this.uploading = false;
      this.countChanged();
      this.onFileUploaded();
    } catch (e) {
      console.error(e);
    }
    this.recursiveUpload(this.queueList.shift());
  }
}
